import styled from 'styled-components'
import Typography from '@material-ui/core/Typography'

export const Subtitle = styled(Typography)`
    max-width: 300px;
    margin: 15px 0 25px 0 !important;
`

export const IconWrapper = styled.div``
